import type { Behavior, Condition } from '@capture/shared';
import { ConditionBuilder } from '../ConditionBuilder';
import { FormulaField } from '../../shared/FormulaField';

interface Props {
  behavior: Extract<Behavior, { kind: 'substitute' }>;
  onChange: (b: Behavior) => void;
  fieldNames: string[];
  advanced: boolean;
}

export function SubstituteBody({ behavior, onChange, fieldNames, advanced }: Props) {
  return (
    <div className="substitute-body">
      {advanced ? (
        <ConditionBuilder
          condition={behavior.when}
          fieldNames={fieldNames}
          onChange={(next: Condition) => onChange({ ...behavior, when: next })}
        />
      ) : (
        <label>
          When (field equals)
          <input
            value={typeof behavior.when.args?.[0] === 'string' ? (behavior.when.args[0] as string).replace(/^\$/, '') : ''}
            onChange={(e) => onChange({ ...behavior, when: { op: 'eq', args: [`$${e.target.value}`, behavior.when.args?.[1] ?? ''] } })}
          />
          <input
            value={String(behavior.when.args?.[1] ?? '')}
            onChange={(e) => onChange({ ...behavior, when: { op: 'eq', args: [behavior.when.args?.[0] ?? '', e.target.value] } })}
          />
        </label>
      )}
      <div className="substitute-body__value">
        <span className="substitute-body__value-caption">Value</span>
        <FormulaField
          value={behavior.value}
          onChange={(next) => onChange({ ...behavior, value: next })}
          fieldNames={fieldNames}
          context="substitute"
          ariaLabel="Value"
        />
      </div>
    </div>
  );
}
